import React from 'react';
import { Link, NavLink, Outlet } from 'react-router';
import { BookMarked, BookOpen, ChevronLeft, CalendarRange, Search, Sun } from 'lucide-react';

// Everything Scripture-shaped lives behind the one Bible door: the reader is the
// landing tab, and the surfaces that used to be separate homepage links are tabs.
const tabs = [
  { to: '/bible/reader', label: 'Reader', icon: BookOpen },
  { to: '/bible/verse-of-the-day', label: 'Verse of the Day', icon: Sun },
  { to: '/bible/explore', label: 'Explore', icon: Search },
  { to: '/bible/plans', label: 'Reading plans', icon: CalendarRange },
  { to: '/bible/memorize', label: 'Memorize', icon: BookMarked }
];

export default function BibleHub() {
  return (
    <div className="vd-surface-shell">
      <div className="vd-surface-tabbar">
        <Link className="vd-surface-back" to="/" aria-label="Back to home">
          <ChevronLeft size={18} aria-hidden="true" />
        </Link>
        <nav className="vd-surface-tabs" aria-label="Bible">
          {tabs.map(({ to, label, icon: Icon }) => (
            <NavLink
              className={({ isActive }) => `vd-surface-tab${isActive ? ' is-active' : ''}`}
              to={to}
              key={to}
            >
              <Icon size={17} aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
